import React from "react";

interface Props {
  color?: string;
  size?: number;
}
const UserIdIcon = ({ color = "#79808A", size = 24 }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.616 16V10.897H14.379V16H13.616ZM15.6189 16V10.897H17.6839C19.1539 10.897 19.9939 11.919 19.9939 13.452C19.9939 14.985 19.1539 16 17.6839 16H15.6189ZM16.3819 15.342H17.5719C18.5589 15.342 19.2099 14.733 19.2099 13.438C19.2099 12.143 18.5519 11.555 17.5719 11.555H16.3819V15.342Z"
        fill={color}
      />
      <path
        d="M6.80124 10.7998C7.85052 10.7998 8.70112 9.94915 8.70112 8.89988C8.70112 7.8506 7.85052 7 6.80124 7C5.75197 7 4.90137 7.8506 4.90137 8.89988C4.90137 9.94915 5.75197 10.7998 6.80124 10.7998Z"
        stroke={color}
      />
      <path
        d="M10.6 14.2792C10.6 15.5033 10.6 16.4958 6.8 16.4958C3 16.4958 3 15.5033 3 14.2792C3 13.0551 4.70145 12.0625 6.8 12.0625C8.89855 12.0625 10.6 13.0551 10.6 14.2792Z"
        stroke={color}
      />
    </svg>
  );
};

export default UserIdIcon;
